module.exports = __webpack_public_path__ + "static/media/img144.96ceaab2.jpg";